<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-file-chart-outline"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ titulo }}
        </div>
      </template>

      <v-select
        id="aie-coordenador"
        v-model="coordenador"
        class="mt-6"
        :items="coordenadores"
        label="Coordenador"
        hint="Obrigatório. Alcança apenas as obras do coordenador presentes na CN43N."
        persistent-hint
        outlined
        clearable
        :loading="carregandoCoordenadores"
        :disabled="loading"
      />
      <v-textarea
        id="aie-peps"
        v-model="textoPeps"
        class="mt-6"
        label="PEPs (opcional)"
        placeholder="Informe um PEP por linha"
        hint="Restringe o relatório a esses PEPs. Os que não pertencem ao coordenador são ignorados."
        persistent-hint
        outlined
        rows="8"
        :disabled="loading || !coordenador"
      />
      <v-alert
        v-if="erro"
        type="error"
        outlined
        dense
        role="alert"
      >
        {{ erro }}
      </v-alert>
      <div class="d-flex justify-end flex-wrap mt-6">
        <v-btn
          text
          class="mr-3"
          :disabled="loading"
          :to="{ name: 'AIE Histórico' }"
        >
          Voltar
        </v-btn>
        <v-btn
          id="aie-agendar"
          color="green"
          :disabled="!coordenador || loading"
          :loading="loading"
          @click="agendar"
        >
          Gerar Relatório
        </v-btn>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import RelatoriosAieService from '@/services/RelatoriosAieService';

export default {
  name: 'AieAdicionar',

  data() {
    return {
      textoPeps: '',
      coordenador: null,
      coordenadores: [],
      carregandoCoordenadores: false,
      loading: false,
      erro: ''
    };
  },

  computed: {
    // A rota do histórico de justificativas reaproveita o formulário e a fila do relatório.
    tipo() {
      return this.$route?.meta?.tipo || 'AIE';
    },
    titulo() {
      return this.tipo === 'AIE' ? 'Novo Relatório IeA' : 'Novo Histórico de Justificativas';
    },
    peps() {
      return [...new Set(this.textoPeps.split(/\r?\n/).map((pep) => pep.trim().toUpperCase()).filter(Boolean))];
    }
  },

  async mounted() {
    this.carregandoCoordenadores = true;
    try {
      const response = await RelatoriosAieService.coordenadores();
      this.coordenadores = response.data.data || [];
    } catch (error) {
      this.erro = 'Não foi possível carregar os coordenadores. Recarregue a página.';
    } finally {
      this.carregandoCoordenadores = false;
    }
  },

  methods: {
    async agendar() {
      if (this.loading || !this.coordenador) return;
      this.loading = true;
      this.erro = '';
      try {
        const response = await RelatoriosAieService.adicionar(this.coordenador, this.peps, this.tipo);
        const ignorados = response.data.data.peps_ignorados || [];
        this.$toast.success('Relatório agendado. Acompanhe a geração no histórico.', '', { position: 'topRight' });
        if (ignorados.length) {
          this.$toast.warning(`${ignorados.length} PEP(s) ignorado(s) por não pertencer(em) ao coordenador.`, '', { position: 'topRight' });
        }
        this.$router.push({ name: 'AIE Histórico' });
      } catch (error) {
        this.erro = error?.response?.data?.erro || error?.data?.erro || 'Não foi possível agendar o relatório. Tente novamente.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
